import { QueryKeysEnum } from '@/enums';
import {
  CreateRecipientProfile,
  RecipientFmtEntity,
  UpdateRecipientProfile,
  UpsertRecipientData,
} from '@/types';
import { FileData } from '@/interfaces';
import APIService from './axios.service';
import { BaseService } from './base.service';

class FmtRecipientService extends BaseService<
  'recipient',
  RecipientFmtEntity,
  CreateRecipientProfile
> {
  constructor() {
    super(QueryKeysEnum.FMT_RECIPIENT);
  }

  updateRecipient = (payload: {
    id: string;
    data: UpdateRecipientProfile;
  }): Promise<RecipientFmtEntity> => {
    const { id, data } = payload;
    return APIService.patch(this.path + '/' + id, data);
  };

  suggestProfileId = (): Promise<string> => {
    return APIService.get(this.path + '/suggested-profile-id');
  };

  generateReport = (ids: string[]): Promise<RecipientFmtEntity> => {
    return APIService.post(this.path + '/generate-report', { ids });
  };

  getFmtReportUrl = (id: string): Promise<FileData> => {
    return APIService.get(this.path + '/' + id + '/fmt-report-url');
  };

  bulkGetFmtReportUrls = (ids: string[]): Promise<FileData[]> => {
    return APIService.get(this.path + '/fmt-report-urls', {
      params: { ids },
    });
  };

  validate = (payload: UpsertRecipientData): Promise<void> => {
    return APIService.post(this.path + '/validate', payload);
  };
}

export const fmtRecipientService = new FmtRecipientService();
